import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Velocity } from '@components/Velocity';
import { HunterAI } from '@components/HunterAI';
import { Tag } from '@components/Tag';

export class HunterAISystem extends System {
  update(_deltaTime: number): void {
    const hunters = this.getEntitiesWithComponents(Position, Velocity, HunterAI, Tag);
    const players = this.getEntitiesWithComponents(Position, Tag).filter(
      e => e.getComponent(Tag)!.value === 'player'
    );
    
    if (players.length === 0) return;

    for (const hunter of hunters) {
      const tag = hunter.getComponent(Tag)!;
      if (tag.value !== 'enemy') continue;

      const position = hunter.getComponent(Position)!;
      const velocity = hunter.getComponent(Velocity)!;
      const ai = hunter.getComponent(HunterAI)!;

      // Find nearest player
      let nearestPlayer = null;
      let minDistance = ai.targetingRange;

      for (const player of players) {
        const playerPos = player.getComponent(Position)!;
        const dx = playerPos.x - position.x;
        const dy = playerPos.y - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < minDistance) {
          minDistance = distance;
          nearestPlayer = playerPos;
        }
      }

      if (nearestPlayer) {
        // Calculate direction to target
        const dx = nearestPlayer.x - position.x;
        const dy = nearestPlayer.y - position.y;
        const targetAngle = Math.atan2(dy, dx);
        
        velocity.angle = targetAngle;
        velocity.speed = velocity.maxSpeed * ai.pursuitSpeed;
      } else {
        // No target in range, patrol
        velocity.speed = velocity.maxSpeed * 0.5;
      }
    }
  }
}